var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('OverviewSummary',{staticClass:"mb-6",attrs:{"summary":_vm.summaryDisplay}}),_vm._v(" "),_c('OverviewKeyTraits',{attrs:{"traits":_vm.topTraitsDisplay,"wheel-mode":_vm.wheelMode}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }